export class SelectLogo {
    agentName!: string;
    agentNumber!: string;
    isChristies: boolean = true;
    lnfLogos: LnfLogos[] = [];
    selectedLogo: LnfSelectedLogos = new LnfSelectedLogos();
}

export class LnfLogos {
    lnfLogoId!: number;
    logoUrl!: string;
}

export class LnfSelectedLogos {
    logoUrl!: string;
    selectedLogoId!: number;
}

export class AccessResponse {
    isDone: boolean = true;
    message!: string;
    extendedProperty: any;
}

export class BiographyDetail {
    agentWebBiography: string = "";
}

export class PhoneNumber {
    areaCode!: string;
    //displayOnPublicSite!: number;
    entityState!: string;
    phoneNumber!: string;
    extension!: string;
    phoneNumberId!: number;
    phoneNumberType!: string;
    fullPhoneNumber!: string;
    uniquedataKey!: string;
    invalid!: boolean;
    rowSelected? : boolean;
    duplicate?: boolean;
    inSufficientLength?: boolean;
    agentPhoneID!:number;
    phoneTypeName!:string;
    displayOnPublicSite!:boolean;
    receiveTextMessagesFlag!:boolean;
}
export class PreferredOffice {
    displayOnPublicSite!: boolean;
    officeFaxNo!: string;
    officeAddress!: string;
    pcNumber!: string;
    officeName!: string;
    isPrimary!: number;
    isSelected!: number;
    officePhone!: string;
    officeTFNo!: string;
    officeTFAreaCode!: string;
    officePhoneAreaCode!: string;
    officeExtn!: string
}

export class MLSCompanies {
    companyAbbreviation!: string;
    companyId!: number
    companyName!: string;
    companyShortName!: string;
    mlsLogo!: string;
    webSiteUrl: any;
    webSiteUrlText: any;
}

export class MLSID {
    agentMlsId!: number
    agentMlsNumber!: string;
    companyId!: number;
    companyShortName: any;
    entityState!: string;
}

export class Delegates {
    mappingId!: number;
    accountId!: number;
    agentNumber!:string;
    agentPrimaryPCNumber!:string;
    isActive!:boolean;
    isEnable!:boolean;
    email!:string;
    firstName!:string;
    lastName!:string;
    entityState!:string;
    showPasswordButton!:boolean;
}

export class AgentInfo {
    agentNumber!:string;
    agentName!:string;
    officialEmailId!:string;
    aceDivision!:string;
  }